import React, { useState, useEffect } from 'react';

export default function TrendingProducts({ products = [] }) {
  const [trendingData, setTrendingData] = useState([]);

  useEffect(() => {
    // Simuler des données de tendance avec vues et upvotes
    const trending = products.slice(0, 6).map((p) => ({
      ...p,
      views: Math.floor(Math.random() * 10000),
      upvotes: Math.floor(Math.random() * 500),
      trend: ['hot', 'trending', 'new', 'bestseller'][Math.floor(Math.random() * 4)],
    }));
    setTrendingData(trending);
  }, [products]);

  if (trendingData.length === 0) return null;

  return (
    <div style={{ marginBottom: '32px' }}>
      <h3 style={{ fontSize: '18px', fontWeight: '700', margin: '0 0 20px 0', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span>🔥</span> Tendance Maintenant
      </h3>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
          gap: '16px',
        }}
      >
        {trendingData.map((product, idx) => (
          <div
            key={idx}
            style={{
              background: 'var(--bg-primary)',
              border: '1px solid var(--border-color)',
              borderRadius: '12px',
              overflow: 'hidden',
              position: 'relative',
              transition: 'all 0.3s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.boxShadow = 'var(--shadow-lg)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            {/* Trending Badge */}
            <div
              style={{
                position: 'absolute',
                top: '8px',
                right: '8px',
                background: product.trend === 'hot' ? '#ff4757' : '#ffa502',
                color: 'white',
                padding: '4px 8px',
                borderRadius: '6px',
                fontSize: '10px',
                fontWeight: '700',
                zIndex: 10,
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              }}
            >
              {product.trend === 'hot' && '🔥 HOT'}
              {product.trend === 'trending' && '📈 TRENDING'}
            </div>

            {/* Image */}
            <div
              style={{
                width: '100%',
                aspectRatio: '1',
                background: 'linear-gradient(135deg, #f0f4f8 0%, #e2e8f0 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '40px',
              }}
            >
              📦
            </div>

            {/* Content */}
            <div style={{ padding: '12px' }}>
              <p style={{ margin: 0, fontSize: '12px', fontWeight: '600', color: 'var(--text-primary)', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                {product.name}
              </p>

              {/* Stats */}
              <div style={{ display: 'flex', gap: '4px', margin: '8px 0', fontSize: '11px', color: 'var(--text-secondary)' }}>
                <span>👁️ {(product.views / 1000).toFixed(1)}k</span>
                <span>👍 {product.upvotes}</span>
              </div>

              {/* Price */}
              <p style={{ margin: 0, fontSize: '14px', fontWeight: '700', background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
                ${product.price}
              </p>

              {/* Action */}
              <button
                style={{
                  width: '100%',
                  marginTop: '10px',
                  padding: '6px',
                  background: 'var(--primary-gradient)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '11px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => (e.target.transform = 'scale(1.02)')}
                onMouseLeave={(e) => (e.target.transform = 'scale(1)')}
              >
                Voir
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
